<!-- navbar-top-collapsed -->
<!--<ul *ngIf="!isOpen"-->
  <ul class="mobile-top-navbar d-flex p-0 m-0">
    <li *ngIf="!isOpen" class="nav-item d-flex align-items-center justify-content-center">
        <a routerLink="/{{logo?.link}}">
            <img [src]="logo?.collapsed?.icon" alt="{{logo?.title|translate}}">
        </a>
    </li>
    <li *ngIf="isOpen" class="nav-item d-flex align-items-center justify-content-center">
        <img [src]="logo?.expanded?.icon" alt="{{logo?.title|translate}}">
    </li>
    <li *ngFor="let item of top"
        class="nav-item mobile-links-items d-flex align-items-center justify-content-center"
        [ngSwitch]="item.type">
        <div *ngIf="item.is_active">
            <!-- components -->
            <div *ngSwitchCase="'component'">
                <div *ngIf="item.link == 'user-login'"
                     class="login-wrap inwards-menu">
                    <user-login [account] = account></user-login>
                </div>
                <div *ngIf="item.link == 'main-header-cart'"
                     class="cart-wrap">
                    <!--<main-header-cart *ngIf="!isDam"></main-header-cart>-->
                    <!--<main-header-media-cart *ngIf="isDam"></main-header-media-cart>-->
                </div>

                <div *ngIf="item.link == 'main-header-search-form'"
                     class="search-wrap">
                    <main-header-search-form></main-header-search-form>
                </div>
            </div>
            <!-- /components -->
            <!-- links -->
<!--            <a *ngSwitchCase="'link'"-->
<!--               [routerLink]="[item.link]"-->
<!--               translate>-->
<!--                <i [ngClass]="item.icon"></i> {{item.title}}-->
<!--            </a>-->
            <!-- links -->
        </div>
    </li>
    <li class="nav-item d-flex align-items-center justify-content-center">
        <button class="btn-collapse bg-transparent border-0"
                (click)="sidebarToggle()">
            <i class="fa fa-bars"></i>
        </button>
    </li>
</ul>
<!--<ng-container *ngIf="displaySearchBar">-->
    <!--<search></search>-->
<!--</ng-container>-->
<!-- end navbar-top-collapsed -->

<!-- navbar-top-expanded -->
<!--<ul *ngIf="isOpen"-->
    <!--class="nav-list navbar-top navbar-top-expanded list-unstyled p-0 m-0">-->
    <!--<li class="list-inline-item">-->
        <!--<button class="btn-collapse bg-transparent border-0"-->
                <!--(click)="sidebarToggle()">-->
            <!--<i class="ion-icon ion-icon-2x ion-close"></i>-->
        <!--</button>-->
    <!--</li>-->
    <!--<li class="list-inline-item logo-wrap pull-right">-->
        <!--<img [src]="logo?.expanded?.icon"-->
             <!--class="ml-3 mr-3"-->
             <!--alt="{{logo?.title|translate}}">-->
    <!--</li>-->
<!--</ul>-->
<!-- end navbar-top-expanded -->
